import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Parallax.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/providers/StoryblokClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Timeline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useStoryblokState"] */ "/app/node_modules/@storyblok/react/dist/core/use-storyblok-state.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@storyblok/react/dist/rsc/live-editing.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
